import { render, staticRenderFns } from "./back-videosNew.vue?vue&type=template&id=fc4fe18e&scoped=true&"
import script from "./back-videosNew.vue?vue&type=script&lang=js&"
export * from "./back-videosNew.vue?vue&type=script&lang=js&"
import style0 from "./back-videosNew.vue?vue&type=style&index=0&id=fc4fe18e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4fe18e",
  null
  
)

export default component.exports